import { useMemo } from 'react';
import { BoxProps } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexRow } from 'components/layout/FlexRow';
import { calcTimeAgo, formatDate } from 'utils/date';
import type { ProjectActivitySummary } from 'types/ActivitySummary';

const containerStyle = {
  justifyContent: 'flex-start',
  columnGap: 'padding_16',
  alignItems: 'baseline',
};

type Props = {
  createdAtDate: ProjectActivitySummary['start_date'];
  sx?: BoxProps['sx'];
};

const CreatedAtDateDisplay = ({ createdAtDate, sx }: Props) => {
  const dateDisplay = useMemo(() => {
    const nowISODate = new Date().toISOString();

    return `${calcTimeAgo(createdAtDate, nowISODate)} • ${formatDate(createdAtDate)}`;
  }, [createdAtDate]);

  if (!createdAtDate) {
    return null;
  }

  return (
    <FlexRow sx={{ ...containerStyle, ...sx }}>
      <Text.SmallLabel color={Colors.TextQuiet}>
        Project first detected by Mercator.ai
      </Text.SmallLabel>
      <Text>{dateDisplay}</Text>
    </FlexRow>
  );
};

export default CreatedAtDateDisplay;
